<div class="malfunction-filter__wrapper" [class.mobile-filter-active]="mobileFilterActive()">
  <div class="malfunction-filter__mobile-button" (click)="toggleFilter()">
    {{ "Malfunction.FilterResults" | translate }}
  </div>
  <div class="malfunction-filter__mobile-show-results" (click)="toggleFilter()">
    {{ "Malfunction.FilterViewResults" | translate }}
  </div>
  <div class="malfunction-filter">
    <malfunction-filter-service
      [(productType)]="productType"
      [(subscription)]="subscription"
      [subscriptionList]="subscriptionList()"
      [productTypes]="productTypes"
      (productTypeChange)="productTypeChanged()"
      (subscriptionChange)="checkBeforeTriggerFilter()"
    />

    @if (subscription()) {
      <malfunction-filter-period
        [(startDate)]="initialStartDate"
        [(endDate)]="initialEndDate"
        (startDateChange)="triggerFilter()"
        (endDateChange)="triggerFilter()"
      />
    }

    <malfunction-filter-type />

    <malfunction-filter-impact />

    <div class="malfunction-filter__section">
      <div class="malfunction-filter__reset" (click)="resetAllFilters()">
        {{ "Malfunction.ResetFilters" | translate }}
      </div>
    </div>
  </div>
</div>
